export default "__VITE_ASSET__DhdGCLG3__"